// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "::ng-deep iframe, ::ng-deep .vizContainer {\n  width: 100% !important;\n  height: calc(100vh - 200px) !important;\n  overflow: hidden;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
